import { useConfig } from 'config/use-config';
import TranslationsProvider from 'contexts/translations';
import { NextPage } from 'next';
import Head from 'next/head';
import NextLink from 'next/link';
import { FormattedMessage, useIntl } from 'react-intl';
import title from '../components/seo/title';

const Error: NextPage<any> = (props) => {
  return (
    <TranslationsProvider>
      <ErrorPageComp {...props} />
    </TranslationsProvider>
  );
};

const ErrorPageComp: NextPage<any> = (props) => {
  const statusCode =
    props.statusCode || (props.initialState && props.initialState.statusCode) || 500;
  const { formatMessage } = useIntl();
  const { commonPagePaths } = useConfig();

  return (
    <>
      <Head>
        {title(
          statusCode === 404
            ? formatMessage({
                id: 'error:page:page-title:page-not-found',
              })
            : formatMessage({
                id: 'error:page:page-title:error',
              })
        )}
      </Head>
      <div
        className="container flex items-center justify-center py-10"
        style={{ minHeight: '40vh' }}
      >
        {statusCode === 404 || statusCode === 505 ? (
          <div className="flex flex-col">
            <NextLink href="/">
              <a aria-label="Pets Deli" className="mr-auto mb-4 lg:mr-0">
                <img
                  src="/images/petsdeli-logo.svg"
                  className="w-auto"
                  alt="Pets Deli"
                  role="presentation"
                />
              </a>
            </NextLink>

            <h1 className="text-primary-main text-3xl font-black">
              <FormattedMessage id="error:page:header" />
            </h1>
            <p className="text-primary-main py-4">
              <FormattedMessage id="error:page:suggestions:header" />
            </p>
            <NextLink href="/">
              <a className="text-brand-blue-neu mb-3 underline">
                <FormattedMessage id="error:page:suggestions:home" />
              </a>
            </NextLink>
            <NextLink href={commonPagePaths.foodConsultation}>
              <a className="text-brand-blue-neu mb-3 underline">
                <FormattedMessage id="error:page:suggestions:foodaid" />
              </a>
            </NextLink>
            <NextLink href="/account">
              <a className="text-brand-blue-neu mb-3 underline">
                <FormattedMessage id="error:page:suggestions:account" />
              </a>
            </NextLink>

            <NextLink href="/cart">
              <a className="text-brand-blue-neu mb-3 underline">
                <FormattedMessage id="error:page:suggestions:cart" />
              </a>
            </NextLink>
          </div>
        ) : (
          <h1 className="text-center">
            <FormattedMessage id="error:page:generic-error-message" />
          </h1>
        )}
      </div>
    </>
  );
};

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
